import { Vector2 } from 'three';

class Rect {
  constructor({ x_min, x_max, y_min, y_max }) {
    this.x_min = x_min;
    this.x_max = x_max;
    this.y_min = y_min;
    this.y_max = y_max;
  }

  includesRect(rect) {
    const { x_min, x_max, y_min, y_max } = rect;
    return this.x_min >= x_min && this.x_max <= x_max && this.y_min >= y_min && this.y_max <= y_max;
  }

  includesPoint(point) {
    const { x, y } = point;
    return x >= this.x_min && x <= this.x_max && y >= this.y_min && y <= this.y_max;
  }

  corner_min() {
    return new Vector2(this.x_min, this.y_min);
  }

  corner_max() {
    return new Vector2(this.x_max, this.y_max);
  }

  is_empty() {
    return this.x_min >= this.x_max || this.y_min >= this.y_max;
  }

  x_size() {
    return this.x_max - this.x_min;
  }

  y_size() {
    return this.y_max - this.y_min;
  }

  area() {
    const width = this.x_size();
    const height = this.y_size();
    return width * height;
  }

  inflate(rate) {
    const width = this.x_size();
    const height = this.y_size();
    const center = this.center();
    const newWidth = width * rate;
    const newHeight = height * rate;
    const newXMin = center.x - newWidth / 2;
    const newXMax = center.x + newWidth / 2;
    const newYMin = center.y - newHeight / 2;
    const newYMax = center.y + newHeight / 2;
    this.x_min = newXMin;
    this.x_max = newXMax;
    this.y_min = newYMin;
    this.y_max = newYMax;
    return new Rect({ x_min: newXMin, x_max: newXMax, y_min: newYMin, y_max: newYMax });
  }

  center() {
    const width = this.x_size() / 2;
    const height = this.y_size() / 2;
    const centerX = this.x_min + width;
    const centerY = this.y_min + height;
    return new Vector2(centerX, centerY);
  }

  clear() {
    this.x_min = 0;
    this.x_max = 0;
    this.y_min = 0;
    this.y_max = 0;
  }

  clone() {
    return new Rect({
      x_min: this.x_min,
      x_max: this.x_max,
      y_min: this.y_min,
      y_max: this.y_max,
    });
  }
}

export default Rect;
